import { createApp } from "vue";
import EditApp from '../components/GroupCard/GroupCardEditMain.vue'
import GCPreviewApp from '../components/GroupCard/GroupCardPreviewMain.vue'
import AssetHelperPlugin from "@/plugins/assetHelperPlugin";

createApp(EditApp)
    .use(AssetHelperPlugin)
    .mount('#groupCardEditMain')
createApp(GCPreviewApp)
    .use(AssetHelperPlugin)
    .mount('#groupCardPreview')
